import { forwardRef, useRef, useEffect } from "react";
import { useNotesDisplay } from './hooks';

const AddNotesDialog = forwardRef<HTMLTextAreaElement>((props, ref) => {
  const { submitHandler, note, setNote } = useNotesDisplay();
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const setRefs = (el: HTMLTextAreaElement | null) => {
    textareaRef.current = el;
    if (typeof ref === "function") ref(el);
    else if (ref) (ref as React.MutableRefObject<HTMLTextAreaElement | null>).current = el;
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 100)}px`;
    }
  }, [note]);

  return (
    <div className="flex items-end gap-2 pt-3 border-t shrink-0">
      <div className="flex-1 flex items-end gap-2 rounded-2xl border bg-muted/30 px-3 py-2 min-h-[44px]">
        <textarea
          ref={setRefs}
          className="flex w-full rounded-md border-input text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm min-h-[36px] max-h-[100px] resize-none border-0 bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 shadow-none px-0 py-1.5 text-base"
          placeholder="Add a note..."
          value={note}
          onChange={(e) => setNote(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              submitHandler();
            }
          }}
          rows={1}
        />
        <button
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 text-primary-foreground shadow hover:brightness-110 h-9 w-9 shrink-0 rounded-full bg-primary hover:bg-primary/90"
          type="button"
          aria-label="Send note"
          onClick={submitHandler}
        >
          <span className="material-icons select-none text-primary-foreground" aria-hidden="true" style={{ fontSize: 18 }}>arrow_upward</span>
        </button>
      </div>
    </div>
  );
});

export default AddNotesDialog;